/**
 * The operator of PrestoBooks (NuFoundry FlexCo, Vienna), the same company that runs PrestoCRM:
 * printed in the app's Impressum, Datenschutzerklärung, AGB and AVV (routes/legal/) and in the
 * website's imprint (web/src/components/Imprint.astro, German and English). Empty optional values
 * are left out of the imprint. Have an Austrian lawyer review the texts once (roadmap LEG-1).
 */
export const OPERATOR = {
  name: "NuFoundry FlexCo",
  legalForm: "Flexible Kapitalgesellschaft (FlexCo)",
  legalFormEn: "flexible limited company (FlexCo)",
  careOf: "c/o welovetaxes OG",
  street: "Alsegger Straße 36/1",
  city: "1180 Wien",
  country: "Österreich",
  countryEn: "Austria",
  register: "FN 648190x",
  court: "Handelsgericht Wien",
  courtEn: "Commercial Court of Vienna (Handelsgericht Wien)",
  /** Optional: left out of the imprint while empty. */
  vatId: "ATU81891124",
  /** Optional: who represents the company (Geschäftsführung); left out while empty. */
  representative: "Paul Csapak",
  business: "Dienstleistungen in der automatischen Datenverarbeitung und Informationstechnik",
  businessEn: "Services in automatic data processing and information technology",
  chamber: "Wirtschaftskammer Wien",
  chamberEn: "Vienna Chamber of Commerce (WKO Wien)",
  email: "office@nufoundry.com",
  phone: "+43 660 363 9 363",
};

/**
 * The AGB version people accept at sign-up (stored on `users.termsVersion`, stamped with
 * `termsAcceptedAt` by server/pb_hooks/main.pb.js). Raise it whenever the AGB or the AVV change.
 */
export const TERMS_VERSION = "2026-10-13";

/** Who processes personal data for PrestoBooks (Art. 28 GDPR), listed in the privacy policy and the AVV. */
export const SUBPROCESSORS = [
  {
    name: "Hetzner Online GmbH",
    purpose: "Hosting von App, Datenbank, Belegen und Diensten",
    location: "Rechenzentrum Falkenstein (DE); Unternehmenssitz Gunzenhausen (DE)",
  },
  {
    name: "Lettermint B.V.",
    purpose: "E-Mail-Versand und Empfang der per E-Mail eingesandten Belege",
    location: "Niederlande (EU), Server ausschließlich in Europa",
  },
  {
    name: "Mistral AI SAS",
    purpose: "Texterkennung und Auslesen der Belege, Antworten und Spracheingabe des Assistenten",
    location: "Frankreich (EU)",
  },
  {
    name: "Stripe Payments Europe, Ltd.",
    purpose: "Zahlungsabwicklung der Abonnements",
    location: "Irland (EU); USA (EU-Standardvertragsklauseln, Data Privacy Framework)",
  },
  {
    name: "Plausible Insights OÜ",
    purpose: "Reichweitenmessung ohne Cookies",
    location: "Estland (EU); Server in Deutschland",
  },
  {
    name: "Functional Software, Inc. (Sentry)",
    purpose: "Technische Fehlerberichte",
    location:
      "EU-Datenregion Frankfurt am Main (DE); Sitz USA (EU-Standardvertragsklauseln, Data Privacy Framework)",
  },
];

export const LEGAL_PAGES = [
  { path: "/impressum", key: "imprint" },
  { path: "/datenschutz", key: "privacy" },
  { path: "/agb", key: "terms" },
  { path: "/avv", key: "dpa" },
] as const;
